import { createSlice } from "@reduxjs/toolkit";
/* eslint-disable no-param-reassign */
const initialState = {
  firstName: "",
  lastName: "",
  email: "",
  accountActivated: "",
  type: "",
  active: "",
  currentPage: "1",
};

export const userFilterSlice = createSlice({
  name: "userFilter",
  initialState,
  reducers: {
    setFirstName: (state, action) => {
      state.firstName = action.payload;
    },
    setLastName: (state, action) => {
      state.lastName = action.payload;
    },
    setEmail: (state, action) => {
      state.email = action.payload;
    },
    setAccountActivated: (state, action) => {
      state.accountActivated = action.payload;
    },
    setType: (state, action) => {
      state.type = action.payload;
    },
    setActive: (state, action) => {
      state.active = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },

    clearFilters: (state) => {
      state.firstName = "";
      state.lastName = "";
      state.email = "";
      state.accountActivated = "";
      state.type = "";
      state.active = "";
    },
    setUserAllFilters: (state, action) => {
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.email = action.payload.email;
      state.accountActivated = action.payload.accountActivated;
      state.type = action.payload.type;
      state.active = action.payload.active;
      state.currentPage = action.payload.currentPage;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setFirstName,
  setLastName,
  setEmail,
  setAccountActivated,
  setType,
  setActive,
  setCurrentPage,
  clearFilters,
  setUserAllFilters,
} = userFilterSlice.actions;

export default userFilterSlice.reducer;
